import React from "react";

import {
  Callout,
  Checkbox,
  Button,
  Icon,
  RadioGroup,
  Radio,
  Tabs,
  Tab,
} from "@blueprintjs/core";
import { DateRangePicker3, TimePrecision } from "@blueprintjs/datetime2";

import { Trans, withTranslation } from "react-i18next";
import i18next from "i18next";
import i18n from "../../../i18n";
import ReactToPrint from "react-to-print";

import Title from "../../Structure/logo";
import FinancialSummary from "./FinancialSummary";
import TableByEq from "./TableByEquipment";
import TableByType from "./TableByType";
import TableByUserType from "./TableByUserType";
import PieVentilCB from "./PieVentilCB";
import TableByPark from "./TableByPark";
import TableByEvent from "./TableByEvent";
import HistoFinancial from "./HistoFinancial";
import ExportReport from "../Export/ExportFinancialReport";

import Periods from "../../Structure/periods";
import PieMeansOfPayment from "./PieMeansOfPayment";
import { mefMontantStr } from "../../../utils/mef";
import { MultiParkSelect } from "../../Structure/ParkSelector";
import PaymentStationsHistory from "./History/PaymentStationHistory";
import PaymentsHistory from "./History/PaymentHistory";

class FinancialReport extends React.Component {
  constructor() {
    var d = new Date();
    var dd = new Date();
    d.setMonth(d.getMonth() - 1);
    d.setHours(0, 0, 0, 0);
    dd.setHours(23, 59, 59, 999);
    var today = [d, dd];

    super();
    this.state = {
      selectedRange: today,
      selectedRangeQueryReady: [null, null],
      displayCount: false,
      handleZero: false,
      printing: false,
      includePrepaid: true,
      filter: "all",
      filterValueParks: [],
    };
    this.generateReport = this.generateReport.bind(this);
  }

  handleDateChange = (dateRange) => {
    if (dateRange[0]) {
      dateRange[0].setSeconds(0);
      dateRange[0].setMilliseconds(0);
    }
    if (dateRange[1]) {
      dateRange[1].setSeconds(59);
      dateRange[1].setMilliseconds(999);
    }
    this.setState({ selectedRange: dateRange });
  };

  generateReport() {
    if (
      this.state.selectedRange[0] !== null &&
      this.state.selectedRange[1] !== null
    ) {
      const params = new URLSearchParams(
        JSON.parse(
          JSON.stringify({
            fr: this.state.selectedRange[0],
            to: this.state.selectedRange[1],
            lg: i18next.language.split("-")[0].toLowerCase(),
            handleZero: this.state.handleZero,
            includePrepaid: this.state.includePrepaid,
          })
        )
      );
      if (this.state.filterValueParks)
        for (const parkpk of this.state.filterValueParks)
          params.append("parks", parkpk);

      this.setState({
        selectedRangeQueryReady: [
          JSON.parse(JSON.stringify(this.state.selectedRange[0].toISOString())),
          JSON.parse(JSON.stringify(this.state.selectedRange[1].toISOString())),
        ],
        urlsearchparams: params,
        update: new Date(),
      });
    }
  }

  render() {
    return (
      <div>
        <Title icon="document" text="financial report" />
        <div className="flexbox-center">
          <DateRangePicker3
            locale={i18next.language}
            shortcuts={[
              { dateRange: Periods.today, label: <Trans>today</Trans> },
              {
                dateRange: Periods.yesterday,
                label: <Trans>yesterday</Trans>,
              },
              {
                dateRange: Periods.lastWeek,
                label: <Trans>last week</Trans>,
              },
              {
                dateRange: Periods.currentMonth,
                label: <Trans>current month</Trans>,
              },
              {
                dateRange: Periods.lastMonth,
                label: <Trans>past month</Trans>,
              },
              {
                dateRange: Periods.lastThreeMonth,
                label: <Trans>past 3 months</Trans>,
              },
              {
                dateRange: Periods.lastSixMonth,
                label: <Trans>past 6 months</Trans>,
              },
              {
                dateRange: Periods.lastYear,
                label: <Trans>past year</Trans>,
              },
              {
                dateRange: Periods.lastTwoYear,
                label: <Trans>past 2 years</Trans>,
              },
            ]}
            allowSingleDayRange={true}
            contiguousCalendarMonths={false}
            timePrecision={TimePrecision.MINUTE}
            value={this.state.selectedRange}
            onChange={this.handleDateChange}
          />
          <div>
            <Checkbox
              checked={this.state.displayCount}
              label={
                <span>
                  <Icon icon="numerical" />{" "}
                  {i18n.t("display number of payments")}
                </span>
              }
              onChange={(cb) => {
                this.setState({ displayCount: cb.target.checked });
              }}
            />
            <Checkbox
              icon="numerical"
              checked={this.state.handleZero}
              label={
                <span>
                  <Icon icon="euro" />{" "}
                  <Trans>take into account payments of</Trans>{" "}
                  {mefMontantStr(0)}
                </span>
              }
              onChange={(cb) => {
                this.setState({ handleZero: cb.target.checked });
              }}
            />
            <Checkbox
              icon="numerical"
              checked={this.state.includePrepaid}
              label={
                <span>
                  <Icon icon="credit-card" />{" "}
                  <Trans>include payments with prepaid means of payment</Trans>
                </span>
              }
              onChange={(cb) => {
                this.setState({ includePrepaid: cb.target.checked });
              }}
            />
            <div>
              <RadioGroup
                label={<Trans>display the activity report for</Trans>}
                onChange={(selection) =>
                  this.setState({
                    filter: selection.target.value,
                    filterValue: undefined,
                  })
                }
                selectedValue={this.state.filter}
              >
                <Radio label={<Trans>all</Trans>} value="all" />
                <Radio label={<Trans>some parks</Trans>} value="park" />
              </RadioGroup>
              {this.state.filter === "park" ? (
                <MultiParkSelect
                  onSelect={(parks) => {
                    this.setState({ filterValueParks: parks });
                  }}
                />
              ) : null}
            </div>
            <Button
              intent="success"
              text={<Trans>generate report</Trans>}
              rightIcon="arrow-right"
              onClick={this.generateReport}
            />
          </div>
        </div>
        <Callout
          intent="warning"
          hidden={this.state.urlsearchparams !== undefined}
        >
          <Trans>please generate a report to visualize data</Trans>
        </Callout>
        <Callout
          intent="primary"
          hidden={this.state.urlsearchparams === undefined}
        >
          <Trans>
            all the amounts presented in this document are INCL. VAT
          </Trans>
        </Callout>
        <br />
        <Tabs
          id="settingmenu"
          fill={true}
          vertical={false}
          renderActiveTabPanelOnly={true}
          defaultSelectedTabId="report"
        >
          <Tab
            id="report"
            title={<Trans>report</Trans>}
            icon="th-list"
            panel={
              <div>
                <div
                  ref={(el) => (this.componentRef = el)}
                  className={this.state.printing ? "printContent" : ""}
                >
                  {this.state.printing ? (
                    <Title text="financial report" />
                  ) : null}

                  <FinancialSummary
                    key={"s" + this.state.update}
                    urlsearchparams={this.state.urlsearchparams}
                    dateRange={this.state.selectedRangeQueryReady}
                  />
                  <br />
                  <div className="flexbox-center">
                    <HistoFinancial
                      key={"pvcb" + this.state.update}
                      urlsearchparams={this.state.urlsearchparams}
                    />
                  </div>
                  <br />
                  <TableByPark
                    key={"p" + this.state.update}
                    urlsearchparams={this.state.urlsearchparams}
                    displayCount={this.state.displayCount}
                    printing={this.state.printing}
                  />
                  <br />
                  <TableByEq
                    key={"e" + this.state.update}
                    urlsearchparams={this.state.urlsearchparams}
                    displayCount={this.state.displayCount}
                    printing={this.state.printing}
                  />
                  <br />
                  {this.state.urlsearchparams !== undefined && (
                    <Callout
                      title={<Trans>distribution of payment method</Trans>}
                    >
                      <div className="flexbox-center">
                        <PieVentilCB
                          key={"pvcb" + this.state.update}
                          urlsearchparams={this.state.urlsearchparams}
                        />
                        <PieMeansOfPayment
                          key={"pmop" + this.state.update}
                          urlsearchparams={this.state.urlsearchparams}
                        />
                      </div>
                    </Callout>
                  )}
                  <br />
                  <TableByType
                    key={"t" + this.state.update}
                    urlsearchparams={this.state.urlsearchparams}
                    displayCount={this.state.displayCount}
                    printing={this.state.printing}
                  />
                  <br />
                  <TableByUserType
                    key={"tut" + this.state.update}
                    urlsearchparams={this.state.urlsearchparams}
                    displayCount={this.state.displayCount}
                    printing={this.state.printing}
                  />
                  <br />
                  <TableByEvent
                    key={"be" + this.state.update}
                    urlsearchparams={this.state.urlsearchparams}
                    displayCount={this.state.displayCount}
                    printing={this.state.printing}
                  />
                  <br />
                </div>
                {/* end of the printable area */}
                {this.state.urlsearchparams !== undefined ? (
                  <div className="flexbox-left">
                    <ExportReport
                      urlsearchparams={this.state.urlsearchparams}
                      dateRange={this.state.selectedRangeQueryReady}
                    />
                    <ReactToPrint
                      trigger={() => {
                        return <Button icon="print" />;
                      }}
                      onBeforeGetContent={() => {
                        this.setState({ printing: true });
                      }}
                      onAfterPrint={() => {
                        this.setState({ printing: false });
                      }}
                      pageStyle={`
                .MuiTableCell-root.MuiTableCell-body.MuiTableCell-alignLeft,
                .MuiButtonBase-root.MuiTableSortLabel-root {
                  font-size: 9pt !important;
                }
                .MuiTableCell-root {border: 1px solid black !important;}`}
                      documentTitle={
                        "FinancialReport-" +
                        new Date(
                          this.state.selectedRangeQueryReady[0]
                        ).toLocaleDateString("fr", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        }) +
                        "-" +
                        new Date(
                          this.state.selectedRangeQueryReady[1]
                        ).toLocaleDateString("fr", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        })
                      }
                      content={() => this.componentRef}
                    />
                  </div>
                ) : null}
              </div>
            }
          />
          <Tab
            id="history"
            title={<Trans>history</Trans>}
            icon="history"
            panel={
              <div>
                <PaymentsHistory
                  key={"ph" + this.state.update}
                  urlsearchparams={this.state.urlsearchparams}
                  dateRange={this.state.selectedRangeQueryReady}
                />
                <br />
                <PaymentStationsHistory
                  key={"psh" + this.state.update}
                  urlsearchparams={this.state.urlsearchparams}
                  dateRange={this.state.selectedRangeQueryReady}
                />
              </div>
            }
          />
        </Tabs>
      </div>
    );
  }
}

export default withTranslation()(FinancialReport);
